import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { CONSTANTS } from '../../../../constants/constants';
import NRHighlightedText from '../../../NRHighlightedText/NRHighlightedText';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import makeStyles from '@mui/styles/makeStyles';
import NRMisconfigurationStatusProviderStyles from './NRMisconfigurationStatusProvider.styles';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { useTheme } from '@mui/material/styles';
const { DATA } = CONSTANTS.MISCONFIGURATION_CHECKS;

const useStyles = makeStyles(NRMisconfigurationStatusProviderStyles);

export const StatusFormatter = ({ value, uppercase = false, small = false }) => {
  const theme = useTheme();
  const classes = useStyles();
  const valueToUse = value.toLowerCase().replace('_', ' ');

  const color =
    valueToUse === DATA.FAILED
      ? theme.palette.statusPaletteWithOpacity[1]
      : valueToUse === DATA.PASSED
      ? theme.palette.statusPaletteWithOpacity[0]
      : theme.palette.statusPaletteWithOpacity[2];
  const icon =
    valueToUse === DATA.FAILED ? (
      <ErrorOutlineOutlinedIcon className={classes.iconsStyles} />
    ) : valueToUse === DATA.PASSED ? (
      <CheckCircleOutlinedIcon className={classes.iconsStyles} />
    ) : null;

  return (
    <div className={classes.invalidityContainer}>
      <NRHighlightedText
        text={uppercase ? valueToUse?.toUpperCase() ?? '' : capitalizeFirstLetter(valueToUse)}
        fontSize={12}
        color={color}
        icon={icon}
        highlightAll={true}
        alphaValue={0.1}
        tooltipContent={CONSTANTS.MISCONFIGURATION_CHECKS.LABELS[value]}
        small={small}
      />
    </div>
  );
};
export const NRMisconfigurationStatusProvider = props => <DataTypeProvider formatterComponent={StatusFormatter} {...props} />;
